import AdjusterReportsIcon from '@/common/assets/icons/adjusterReports.svg?react';
import CardSquare from '@/common/components/cardSquare/CardSquare';
import { AdjusterReportsCardProps } from '@/modules/FileDetail/components/entryTabs/Cards/AdjusterReportsCard/AdjusterReportsCard.types';
import { FILE_DETAIL_LINKS } from '@/modules/FileDetail/FileDetailLinks';
import { useNavigate, useParams } from 'react-router-dom';

const AdjusterReportsCard = ({ title }: AdjusterReportsCardProps) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const goToFile = () => {
    navigate(FILE_DETAIL_LINKS.adjusterReport(+id!));
  };
  return (
    <CardSquare
      title={title}
      onClick={goToFile}
      renderIcon={() => <AdjusterReportsIcon />}
    />
  );
};
export default AdjusterReportsCard;
